import { Role, SignInResponse } from '../services/auth-service/types';

export const UserUtils = {
  isSuperUser: (cUser: SignInResponse['idToken']['payload']) => {
    if (!cUser?.['custom:roles']) return false;
    const roles = cUser['custom:roles'].split(',') as Role[];
    const rolesAccess = [Role.SuperUser];
    let canAccess = false;
    roles.forEach(role => {
      if (rolesAccess.includes(role)) {
        canAccess = true;
      }
    });
    return canAccess;
  },
};
